module.exports = __webpack_public_path__ + "static/media/027.4c93127c.jpg";